import * as yup from 'yup';
import {
  Data,
  GivingStrategy,
} from '../../../../CharitableGivingWorkflow/stages/CharitableGiving/api/useCharitableGivingQuery';

import { dafAccountValidation } from '../../../../CharitableGivingWorkflow/stages/CharitableGiving/steps/DafAccount/DafAccount.meta';
import {
  dafDonationEndYearValidation,
  dafDonationStartYearValidation,
} from '../../../../CharitableGivingWorkflow/stages/CharitableGiving/steps/DafDonationYear/DafDonationYear.meta';
import {
  donationAmountValidation,
  maximizeDonationsValidation,
} from '../../../../CharitableGivingWorkflow/stages/CharitableGiving/steps/DonationAmount/DonationAmount.meta';
import {
  donationEndYearValidation,
  donationStartYearValidation,
} from '../../../../CharitableGivingWorkflow/stages/CharitableGiving/steps/DonationYear/DonationYear.meta';
import { donorValidation } from '../../../../CharitableGivingWorkflow/stages/CharitableGiving/steps/Donor/Donor.meta';
import { fundAccountValidation } from '../../../../CharitableGivingWorkflow/stages/CharitableGiving/steps/FundAccounts/FundAccounts.meta';

export const UPSERT_GOAL_URL = '/Consumer/GoalUpdate/SaveCharitableGivingGoal';

export const FORM_ID = 'ProfileGoals--CharitableGiving--Form';

export interface CharitableGoalDataDTO extends Data {
  isRecurring: boolean;
  assetBucketingIndices: number[];
}

export const grantYearValidation = yup.object().shape({
  grantStartYear: yup.object().nullable(),

  grantEndYear: yup
    .object()
    .nullable()
    // eslint-disable-next-line func-names
    .test('is-greater', 'End Year cannot be before the Start Year.', function(value) {
      const { grantStartYear } = this.parent;

      if (!value || !grantStartYear) {
        return true;
      }

      if (!value.year) {
        return true;
      }

      return value.year >= grantStartYear.year;
    }),
});

const charityNameValidation = yup
  .string()
  .nullable()
  .required("Please, enter the charity's name");

const kindOfPropertyValidation = yup
  .number()
  .nullable()
  .required('Please specify a kind of property.');

export const dafValidation = yup.object().shape({
  dafDonationStartYear: dafDonationStartYearValidation,
  dafDonationEndYear: dafDonationEndYearValidation,
  donationAmount: donationAmountValidation,
  dafAccount: dafAccountValidation,
  donor: donorValidation,
});

export const outrightGiftsToCharityValidation = yup.object().shape({
  charityName: charityNameValidation,
  kindOfProperty: kindOfPropertyValidation,
  donationStartYear: donationStartYearValidation,
  donor: donorValidation,
  donationEndYear: donationEndYearValidation,
  donationAmount: donationAmountValidation,
  fundAccounts: fundAccountValidation,
});

export const qualifiedCharitableDonationsValidation = yup.object().shape({
  charityName: charityNameValidation,
  donor: donorValidation,
  donationStartYear: donationStartYearValidation,
  donationEndYear: donationEndYearValidation,
  donationAmount: donationAmountValidation,
  maximizeDonations: maximizeDonationsValidation,
  fundAccounts: fundAccountValidation,
});

export const validationMap = {
  [GivingStrategy.DonationToDAF]: dafValidation,
  [GivingStrategy.OutrightGiftsToCharity]: outrightGiftsToCharityValidation,
  [GivingStrategy.QualifiedCharitableDonations]: qualifiedCharitableDonationsValidation,
};
